import { Outlet, Navigate } from "react-router-dom";
import { useUser } from "@/context";

const PrintLayout = () => {
    useUser();

    const isAuthenticated = localStorage.getItem("is_logged_in") === "true";

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    return (
        <div className="bg-white">
            <Outlet />
        </div>
    );
};

export default PrintLayout;
